var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.approvalsHistory && _vm.approvalsHistory.length > 0
    ? _c(
        "div",
        [
          _c(
            "h2",
            {
              staticClass: "atmo-hash-jump-point font-weight-bold",
              attrs: { id: "approvals-history" },
            },
            [_vm._v("История согласований")]
          ),
          _c(
            "b-table-simple",
            { staticClass: "table-atmo", attrs: { small: "" } },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "py-1" }, [
                    _vm._v("Представитель заказчика"),
                  ]),
                  _c("th", { staticClass: "py-1" }, [
                    _vm._v("Представитель ГРБС / МО"),
                  ]),
                  _c("th", { staticClass: "py-1" }, [_vm._v("Комментарий")]),
                  _c("th", { staticClass: "py-1" }, [_vm._v("Дата запроса")]),
                  _c("th", { staticClass: "py-1" }, [_vm._v("Дата ответа")]),
                  _c("th", { staticClass: "py-1" }, [_vm._v("Статус")]),
                ]),
              ]),
              _c(
                "tbody",
                _vm._l(_vm.approvalsHistory, function (approval) {
                  return _c("tr", { key: approval.id }, [
                    _c(
                      "td",
                      { staticClass: "align-text-top py-1" },
                      [
                        approval.sent_by.name
                          ? [
                              _c("b", [_vm._v("ФИО: ")]),
                              _vm._v(_vm._s(approval.sent_by.name)),
                              _c("br"),
                            ]
                          : _vm._e(),
                        approval.sent_by.phone
                          ? [
                              _c("b", [_vm._v("Телефон: ")]),
                              _vm._v(
                                _vm._s(_vm.$parsePhone(approval.sent_by.phone))
                              ),
                              _c("br"),
                            ]
                          : _vm._e(),
                        approval.sent_by.email
                          ? [
                              _c("b", [_vm._v("Email: ")]),
                              _vm._v(_vm._s(approval.sent_by.email)),
                              _c("br"),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "td",
                      { staticClass: "align-text-top py-1" },
                      [
                        approval.replied_by.name
                          ? [
                              _c("b", [_vm._v("ФИО: ")]),
                              _vm._v(_vm._s(approval.replied_by.name)),
                              _c("br"),
                            ]
                          : _vm._e(),
                        approval.replied_by.phone
                          ? [
                              _c("b", [_vm._v("Телефон: ")]),
                              _vm._v(
                                _vm._s(
                                  _vm.$parsePhone(approval.replied_by.phone)
                                )
                              ),
                              _c("br"),
                            ]
                          : _vm._e(),
                        approval.replied_by.email
                          ? [
                              _c("b", [_vm._v("Email: ")]),
                              _vm._v(_vm._s(approval.replied_by.email)),
                              _c("br"),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "td",
                      { staticClass: "align-text-top py-1" },
                      [
                        approval.comment
                          ? [
                              _c("b", [_vm._v("Комментарий: ")]),
                              _vm._v(_vm._s(approval.comment)),
                              _c("br"),
                            ]
                          : _vm._e(),
                        approval.attachment
                          ? [
                              _c("b", [_vm._v("Приложенный документ: ")]),
                              _c(
                                "a",
                                {
                                  staticClass: "green-link",
                                  attrs: {
                                    href: _vm.$getAttachmentDownloadLink(
                                      approval.attachment.id
                                    ),
                                  },
                                },
                                [_vm._v(_vm._s(approval.attachment.name))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("td", { staticClass: "align-text-top py-1" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            approval.sent_at
                              ? _vm.$formatDateTime(approval.sent_at)
                              : "—"
                          ) +
                          " "
                      ),
                    ]),
                    _c("td", { staticClass: "align-text-top py-1" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            approval.replied_at
                              ? _vm.$formatDateTime(approval.replied_at)
                              : "—"
                          ) +
                          " "
                      ),
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-text-top py-1" },
                      [
                        _c(
                          "b-badge",
                          {
                            attrs: {
                              variant: _vm.statusBadgeVariant(
                                approval.status.id
                              ),
                              pill: "",
                            },
                          },
                          [_vm._v(_vm._s(approval.status.title))]
                        ),
                      ],
                      1
                    ),
                  ])
                }),
                0
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }